import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    attrs: {
      "title": _vm.modalTitle,
      "data-sign": "product_batch_modal",
      "width": 860,
      "wrap-class-name": "modal-body"
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData,
      "data-sign": "product_batch_form"
    }
  }, [_c('my-table', {
    attrs: {
      "columns": _vm.columns,
      "bordered": "",
      "data-sign": "product_batch_table",
      "data-source": _vm.formData.batch_list,
      "row-key": "_rowKey"
    },
    scopedSlots: _vm._u([{
      key: "batch_length",
      fn: function (ref) {
        var record = ref.record;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "batch_list." + index + ".batch_length",
            "rules": _vm.formDataRule['batch_list.*.batch_length']
          }
        }, [_c('a-input', {
          attrs: {
            "fbu-invalid-analyse-tag": true,
            "disabled": _vm.isView,
            "placeholder": _vm.t('请输入生产批次号总长度')
          },
          on: {
            "change": function ($event) {
              return _vm.handleBatchLengthChange(index, record);
            }
          },
          model: {
            value: record.batch_length,
            callback: function ($$v) {
              _vm.$set(record, "batch_length", $$v);
            },
            expression: "record.batch_length"
          }
        })], 1)];
      }
    }, {
      key: "batch_prefix",
      fn: function (ref) {
        var record = ref.record;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "batch_list." + index + ".batch_prefix",
            "rules": _vm.getPrefixRules(record)
          }
        }, [_c('a-input', {
          attrs: {
            "fbu-invalid-analyse-tag": true,
            "disabled": _vm.isView,
            "placeholder": _vm.t('请输入前缀')
          },
          on: {
            "change": function ($event) {
              return _vm.handlePrefixSuffixChange(index, 'batch_prefix');
            }
          },
          model: {
            value: record.batch_prefix,
            callback: function ($$v) {
              _vm.$set(record, "batch_prefix", $$v);
            },
            expression: "record.batch_prefix"
          }
        })], 1)];
      }
    }, {
      key: "batch_suffix",
      fn: function (ref) {
        var record = ref.record;
        var index = ref.index;
        return [_c('a-form-model-item', {
          attrs: {
            "prop": "batch_list." + index + ".batch_suffix",
            "rules": _vm.getSuffixRules(record)
          }
        }, [_c('a-input', {
          attrs: {
            "fbu-invalid-analyse-tag": true,
            "disabled": _vm.isView,
            "placeholder": _vm.t('请输入后缀')
          },
          on: {
            "change": function ($event) {
              return _vm.handlePrefixSuffixChange(index, 'batch_suffix');
            }
          },
          model: {
            value: record.batch_suffix,
            callback: function ($$v) {
              _vm.$set(record, "batch_suffix", $$v);
            },
            expression: "record.batch_suffix"
          }
        })], 1)];
      }
    }, {
      key: "operation",
      fn: function (ref) {
        var index = ref.index;
        return [!_vm.isView ? _c('a', {
          attrs: {
            "href": "javascript:"
          },
          on: {
            "click": function ($event) {
              return _vm.handleRemoveRow(index);
            }
          }
        }, [_c('a-icon', {
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "type": "delete"
          }
        })], 1) : _c('span', [_vm._v("--")])];
      }
    }])
  }), _vm.isAdd ? _c('div', {
    staticClass: "table-border-box",
    staticStyle: {
      "border-top": "none"
    }
  }, [_c('div', {
    staticClass: "table-footer"
  }, [_c('a-button', {
    attrs: {
      "type": "link",
      "icon": "plus",
      "data-sign": "product_batch_add_row_btn",
      "fbu-analyse-name": $t("\u6DFB\u52A0")
    },
    on: {
      "click": _vm.handleAddRow
    }
  }, [_vm._v(_vm._s(_vm.t('添加')))]), _c('a-button', {
    attrs: {
      "type": "link",
      "data-sign": "product_batch_delete_all_btn",
      "disabled": _vm.formData.batch_list.length === 0,
      "fbu-analyse-name": $t("\u5168\u90E8\u5220\u9664")
    },
    on: {
      "click": _vm.handleDeleteAll
    }
  }, [_vm._v(_vm._s(_vm.t('全部删除')))])], 1)]) : _vm._e(), _c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u72B6\u6001"),
      "label": _vm.t('状态'),
      "prop": "enable_status",
      "rules": _vm.formDataRule['enable_status']
    }
  }, [_c('my-select', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "show-search": "",
      "allow-clear": "",
      "placeholder": _vm.t('请选择状态'),
      "disabled": _vm.isView
    },
    model: {
      value: _vm.formData.enable_status,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enable_status", $$v);
      },
      expression: "formData.enable_status"
    }
  }, _vm._l(_vm.statusEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "product_batch_cancel_btn",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), !_vm.isView ? _c('a-button', {
    attrs: {
      "type": "primary",
      "data-sign": "product_batch_submit_btn",
      "loading": _vm.submitLoading,
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))]) : _vm._e()], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };